import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Button } from '@mui/material';

import { queueCancelledFutureBookingsReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth } from '~/services/TimeService';

import ErrorDisplay from '../ErrorDisplay';
import PermissionedComponent from '../PermissionedComponent';

const formSchema: RJSFSchema = {
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
  },
};

const formData = {
  startAt: formatDateISO(startOfMonth()),
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
};

export default function ExportCancelledFutureBookingsReportForm() {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (event: IChangeEvent) => {
    const { startAt } = event.formData;

    queueCancelledFutureBookingsReport({ startAt })
      .then(function () {
        setSuccessMessage(true);
      })
      .catch(function (err) {
        setError(err.message);
      });
  };

  return (
    <PermissionedComponent>
      <Form
        schema={formSchema}
        uiSchema={uiSchema}
        formData={formData}
        onSubmit={handleSubmit}
        validator={validator}
        showErrorList={false}
      >
        <Button type="submit" variant="contained">
          Email Cancelled Future Booking Report
        </Button>

        {error && <ErrorDisplay message={error} />}

        {successMessage && (
          <Alert severity="success">
            <p>Your report is queued for delivery and will be emailed shortly.</p>
          </Alert>
        )}
      </Form>
    </PermissionedComponent>
  );
}
